define("resources/glassware", function(){
    return {
        "Erlenmeyers":{
            "250mL":{
                name: "250_mL_Flask",
                maxVolume: .25,
                icon: "styles/icons/250mLFlask.svg"
            },"500mL":{
                name: "500_mL_Flask",
                maxVolume: .5,
                icon: "styles/icons/500mLFlask.svg"
            },
            "1000mL":{
                name: "1000_mL_Flask",
                maxVolume: 1,
                icon: "styles/icons/1000mLFlask.svg"
            }
        },
        "Graduated_Cylinders":{
            "10mL":{
                name: "10_mL_Graduated_Cylinder",
                maxVolume: .01,
                icon: "styles/icons/10mLGraduatedCylinder.svg"
            },
            "25mL":{
                name: "25_mL_Graduated_Cylinder",
                maxVolume: .025,
                icon: "styles/icons/25mLGraduatedCylinder.svg"
            },
            "50mL":{
                name: "50_mL_Graduated_Cylinder",
                maxVolume: .05,
                icon: "styles/icons/50mLGraduatedCylinder.svg"
            }
        },
        "Pipettes":{
            "5mL":{
                name: "5_mL_Pipette",
                maxVolume: .005,
                icon: "styles/icons/5mLPipette.svg"
            },
            "10mL":{
                name: "10_mL_Pipette",
                maxVolume: .01,
                icon: "styles/icons/10mLPipette.svg"
            },
            "25mL":{
                name: "25_mL_Pipette",
                maxVolume: .025,
                icon: "styles/icons/25mLPipette.svg"
            },
            "Disposable":{
                name: "Disposable_Pipette",
                maxVolume: .001,
                icon: "styles/icons/DisposablePipette.svg"
            }
        },
        "Beakers":{
            "250mL":{
                name: "250_mL_Beaker",
                maxVolume: .25,
                icon: "styles/icons/250mLBeaker.svg"
            },
            "600mL":{
                name: "600_mL_Beaker",
                maxVolume: .6,
                icon: "styles/icons/600mLBeaker.svg"
            },
            "1000mL":{
                name: "1000_mL_Beaker",
                maxVolume: 1,
                icon: "styles/icons/1000mLBeaker.svg"
            }
        },
        "Volumetric_Flasks":{
            "100mL":{
                name: "100_mL_Volumetric_Flask",
                maxVolume: .1,
                icon: "styles/icons/100mLVolumetricFlask.svg"
            },
            "250mL":{
                name: "250_mL_Volumetric_Flask",
                maxVolume: .25,
                icon: "styles/icons/250mLVolumetricFlask.svg"
            },
            "500mL":{
                name: "500_mL_Volumetric_Flask",
                maxVolume: .5,
                icon: "styles/icons/500mLVolumetricFlask.svg"
            },
            "1000mL":{
                name: "1000_mL_Volumetric_Flask",
                maxVolume: 1,
                icon: "styles/icons/1000mLVolumetricFlask.svg"
            }
        },
        "Other":{
            "Foam_Cup": {
                name: "Foam_Cup",
                maxVolume: .2,
                icon: "styles/icons/foamCup.svg"
            },
            "Weigh_Boat": {
                name: "Weigh_Boat",
                maxVolume: .0877,
                icon: "styles/icons/weighBoat.svg"
            },
            "50_mL_Burette": {
                name: "50_mL_Burette",
                maxVolume: .05,
                icon: "styles/icons/50mLBurette.svg"
            }
        }
    }
});
